module.exports = __webpack_public_path__ + "img/oculos.3400237a.svg";